import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Alert from '../Base/Alert'
import { TextField } from '../Base/Form'

const Modify = ({ dictionary, endpoint }) => {
  const { control, handleSubmit } = useForm()
  const [loading, setLoading] = useState(false)
  const [errorMessages, setErrorMessages] = useState()
  const onSubmit = async (data) => {
    try {
      setErrorMessages(null)
      setLoading(true)
      // console.log('payload', data)
      const response = await postData(endpoint, data)
      if (response.success) {
        //redirect
      } else {
        //show errors
      }
    } catch {
      //show general error msg
      //   setErrorMessages(['Wrong reference number'])
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      {errorMessages && <Alert messages={errorMessages} />}
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="s-modify-search__form s-modify-search__form--tabbed">
        <TextField
          name="referenceNumber"
          label={dictionary.referenceNumberLabel}
          control={control}
        />
        <TextField
          name="surname"
          label={dictionary.surnameLabel}
          control={control}
        />
        <button
          type="button"
          className="btn btn-primary"
          disabled={loading}
          title={dictionary.modifyBtn}>
          {dictionary.modifyBtn}
        </button>
      </form>
    </>
  )
}

export default Modify
